<template>
    <div>
      <div style="position: fixed; z-index:9999;background-color: white; width: 100%;height: 50px;">
        <van-search placeholder="搜商品名称" v-model.trim="listQuery.key"   @search="onSearch" />
      </div>
      <div style="height: 60px;"></div>

      <van-tree-select :items="items" :main-active-index.sync="active" style="width: 100%;" @click-nav="onNavClick">
        <template #content >
          <div >
            <van-card v-for="(goods,index) in goodsList1" :key="index"
                      :price="toDecimal(goods.je)"
                      :desc="goods.spContent"
                      :title="goods.spName"
                      :thumb="goods.productPicture"
                      @click="viewGoodsDetail(goods.id)"
            />
          </div>
        </template>
      </van-tree-select>
      <br><br><br>
   
    </div>
</template>

<script>

import {
  Card,
  Cell,
  CellGroup,
  Col,
  Divider,
  Icon,
  List,
  Row,
  Search,
  Sidebar,
  SidebarItem,
  Tab,
  Tabs,
  Toast,
  TreeSelect
} from 'vant';


export default {
  components: {
    [Divider.name]: Divider,
    [List.name]: List,
    [Toast.name]:Toast,
    [Row.name]: Row,
    [Col.name]: Col,
    [Icon.name]: Icon,
    [Cell.name]: Cell,
    [CellGroup.name]: CellGroup,
    [Tab.name]: Tab,
    [Tabs.name]: Tabs,
    [Card.name]: Card,
    [Search.name]:Search,
    [Sidebar.name]: Sidebar,
    [SidebarItem.name]: SidebarItem,
    [TreeSelect.name]: TreeSelect
  },
  data() {
    return {
      searchKey:'',
      loading:false,
      finished:false,
      goodsList1: [],
      listQuery: {
        page: 1,
        limit: 20,
        key:''   //搜索的内容
      },
      categoryId:0,
      active: 0,
      items: []
    }
  },
  mounted(){
     this.init()
  },
  methods: {

    onSearch(val) {
      if (val.indexOf("%") != -1) {
        Toast("禁止输入%,!,*等特殊符号");
        return;
      }
       sessionStorage.setItem("spName",val);
 
      this.$router.push({path: '/searchProduct'});

        
    },
    init(){
      this.selectTree();
    },
    selectTree(){
        let _this = this;
        let url = "/index/tree";
        return new Promise((resolve, reject) => {
          _this.$axios
              .get(url)
              .then(data => {
                var val = [];
                var newData = [];
                for(var i = 0; i < data.length; i++){
                  val.push(data[i].label);
                  var obj = {
                    text: data[i].label,
                    id: data[i].id
                  };
                  newData.push(obj);
                }
                this.items = newData;
                this.onNavClick(0);
              }).catch(erro => {
                reject(erro);

              });
        })
    },
    onNavClick(val){  //左边点击事件

      let spClassid=this.items[val].id;
      this.categoryId=this.items[val].id;
      let params={"spClassid":spClassid};
      this.searchGoods(params);
      this.listQuery.key="";

    },
    searchGoods(params){

      let url = "/index/treeDetails";
      return new Promise((resolve, reject) => {
        this.$axios
            .get(url,params)
            .then(data => {
              this.goodsList1 = data.data
            }).catch(erro => {
          reject(erro);

        });
      })
    },
    // 商品详情
    viewGoodsDetail(id) {  //查看商品详情
       this.$router.push({name:'goods',query: {id:id}})
    },
 

  }
};
</script>

<style lang="less">

// .van-sidebar-item--select::before {
//     background-color: #2f72f3 !important;
// };


    .user {
        &-poster {
            width: 100%;
            height: 53vw;
            display: block;
        }

        &-group {
            margin-bottom: 15px;
        }

        &-links {
            padding: 15px 0;
            font-size: 12px;
            text-align: center;
            background-color: #fff;

            .van-icon {
                display: block;
                font-size: 24px;
            }
        }
    }

    .van-tree-select__content {
    height: 800px !important;
}
</style>
